import { render } from "./oauth-submit.vue?vue&type=template&id=59558518&scoped=true"
import script from "./oauth-submit.vue?vue&type=script&lang=js"
export * from "./oauth-submit.vue?vue&type=script&lang=js"

import "./oauth-submit.vue?vue&type=style&index=0&id=59558518&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/yunsi/bzcircle-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59558518"]])

export default __exports__